export default __webpack_public_path__ + "static/Britannia-961644878d360ec4ed90877817715983.png";